import { render, staticRenderFns } from "./ResourceUserEditor.vue?vue&type=template&id=2bb0f31b"
import script from "./ResourceUserEditor.vue?vue&type=script&lang=js"
export * from "./ResourceUserEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports